import { Banner, Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useGetUserCustomerData } from 'Containers/Account/components/AccountDeleteForm/components/EmbedForm/hooks';
import { stages } from 'Constants/stages';
import { FRONT_PLANS, plansNameMapping } from 'Constants/plans';
import { openLinkInNewTab } from 'Utils/links';
import { NOT_SUCCESS_LINK } from 'Constants/helpsUrl';
import { TaxScreenType } from 'Types/common';
import { addDaysToDate } from '../utils';
import * as Styled from './styles';
import { afterFlowLotties } from './utils';

const AfterFlowScreens = ({ tax }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const customer = useGetUserCustomerData();
  const { taxYear, stage, filingInfo } = tax;
  const notIsFlex = customer && plansNameMapping(customer?.activePlan?.name) !== FRONT_PLANS.FLEX;
  const notIsToReturn = notIsFlex && stage === stages.FINISHED;

  return (
    <FlexContainer fullWidth fullHeight direction="column" gap="dimension_16">
      {(stage === stages.FINISHED_NOT_SUCCESS ||
        stage === stages.PENDING_AUTOMATIC_MODIFICATIONS) && (
        <Banner
          hasIcon
          label={t(`TaxScreen.${stage}.banner`)}
          mode="warning"
          id="pending-banner"
          layout="embed"
        />
      )}
      {(stage === stages.PENDING_MANUAL_MODIFICATIONS || stage === stages.FILED_MANUAL) && (
        <Banner
          hasIcon
          label={t(`TaxScreen.${stage}.banner`)}
          mode="default"
          id="pending-banner"
          layout="embed"
        />
      )}
      <Styled.Container
        fullWidth
        fullHeight
        justify="center"
        direction="column"
        align="center"
        gap="dimension_08"
      >
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t(`TaxScreen.${stage}.title`, { context: notIsToReturn && 'notToReturn' })}
        </Text>
        <Styled.StyledLottie
          options={{
            path: notIsToReturn ? afterFlowLotties[stages.FILED_MANUAL] : afterFlowLotties[stage],
            rendererSetting: { progressiveLoad: true },
          }}
        />
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t(`TaxScreen.${stage}.info`)}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t(`TaxScreen.${stage}.subtitle`, {
            context: notIsToReturn && 'notToReturn',
            date: addDaysToDate(filingInfo?.recent?.filedAt, 40),
          })}
        </Text>
        {stage === stages.PENDING_MANUAL_MODIFICATIONS && (
          <Text type="paragraphs" color="dark" size="S_S_S" align="center">
            {t(`TaxScreen.${stage}.extraInfo`, {
              context: notIsToReturn && 'notToReturn',
              date: addDaysToDate(filingInfo?.recent?.filedAt, 20),
            })}
          </Text>
        )}
        <FlexContainer direction="column" align="center" justify="center">
          <Styled.ButtonsWrapper gap="dimension_16">
            {(stage === stages.FINISHED_NOT_SUCCESS ||
              stage === stages.PENDING_AUTOMATIC_MODIFICATIONS) && (
              <Buttons.Classic
                label={t('AfterFlow.button.label')}
                mode="primary"
                size="m"
                onClick={() => openLinkInNewTab(NOT_SUCCESS_LINK)}
              />
            )}
          </Styled.ButtonsWrapper>
        </FlexContainer>
      </Styled.Container>
    </FlexContainer>
  );
};

export default AfterFlowScreens;
